// @flow
export const GUTTER_THEME_API = {
  gutter: ''
};
